import { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";

import {
  doc,
  getDoc,
  collection,
  getDocs
} from "firebase/firestore";

import { db } from "../firebase";

import { useShop } from "../context/ShopContext";

import "./ProductDetails.css";


function ProductDetails() {

  const { id } = useParams();


  const {
    addToCart,
    toggleFavorite,
    favorites
  } = useShop();


  const [product, setProduct] = useState(null);

  const [relatedProducts, setRelatedProducts] = useState([]);

  const [activeImage, setActiveImage] = useState(0);

  const [selectedColor, setSelectedColor] = useState("");

  const [selectedSize, setSelectedSize] = useState("");

  const [zoom, setZoom] = useState(false);


  useEffect(() => {

    const loadProduct = async () => {

      try {

        const ref = doc(
          db,
          "products",
          id
        );


        const snap = await getDoc(ref);


        if (!snap.exists()) {

          return;

        }


        const data = {

          id: snap.id,

          ...snap.data()

        };


        setProduct(data);


        // =========================
        // GET ALL PRODUCTS
        // =========================

        const productsSnap = await getDocs(
          collection(db, "products")
        );


        const productsData =
          productsSnap.docs.map(item => ({

            id: item.id,

            ...item.data()

          }));


        // =========================
        // RELATED PRODUCTS
        // =========================

        const related =
          productsData.filter(item => {


            // Don't show the current product

            if (item.id === data.id) {

              return false;

            }


            // =========================
            // ACCESSORY
            // Example:
            // Baby → Accessories → Hats
            // =========================

            if (data.accessory) {

              return (

                item.category ===
                  data.category &&

                item.subCategory ===
                  data.subCategory &&

                item.accessory ===
                  data.accessory

              );

            }


            // =========================
            // SUB CATEGORY
            // Example:
            // Baby → Girl
            // Baby → Boy
            // Baby → Hospital Sets
            // =========================

            if (data.subCategory) {

              return (

                item.category ===
                  data.category &&

                item.subCategory ===
                  data.subCategory

              );

            }


            // =========================
            // MAIN CATEGORY
            // Example:
            // Girls
            // Boy
            // Toys
            // Gifts
            // Nursery
            // Back to School
            // =========================

            return (

              item.category ===
                data.category

            );

          });


        setRelatedProducts(related);


      } catch (error) {

        console.error(
          "Error loading product:",
          error
        );

      }

    };


    loadProduct();


  }, [id]);


  // =========================
  // LOADING
  // =========================

  if (!product) {

    return (

      <h2>
        Loading...
      </h2>

    );

  }


  const images =
    product.images || [];


  // =========================
  // NEXT IMAGE
  // =========================

  const nextImage = () => {

    setActiveImage(prev =>

      prev === images.length - 1

        ? 0

        : prev + 1

    );

  };


  // =========================
  // PREVIOUS IMAGE
  // =========================

  const prevImage = () => {

    setActiveImage(prev =>

      prev === 0

        ? images.length - 1

        : prev - 1

    );

  };


  return (

    <div className="details-page">


      {/* BACK */}

      <Link
        to="/"
        className="back-btn"
      >
        ← Home
      </Link>


      {/* =========================
          PRODUCT DETAILS
      ========================= */}

      <div className="product-details">


        {/* =========================
            GALLERY
        ========================= */}

        <div className="gallery">


          <div className="product-header">


            <h1>
              {product.name}
            </h1>


            <button
              className="favorite-btn"
              onClick={() =>
                toggleFavorite(product)
              }
            >

              {favorites.some(
                item =>
                  item.id === product.id
              )

                ? "❤️"

                : "🤍"

              }

            </button>


          </div>


          {/* MAIN IMAGE */}

          <div className="image-container">


            <button
              className="arrow left"
              onClick={prevImage}
            >
              ❮
            </button>


            {images.length > 0 && (

              <img
                src={images[activeImage]}
                alt={product.name}
                className={
                  zoom
                    ? "main-image zoom"
                    : "main-image"
                }
                onClick={() =>
                  setZoom(!zoom)
                }
              />

            )}


            <button
              className="arrow right"
              onClick={nextImage}
            >
              ❯
            </button>


          </div>


          {/* THUMBNAILS */}

          <div className="thumbnails">


            {images.map(
              (img, index) => (

                <img
                  key={index}
                  src={img}
                  alt={product.name}
                  className={
                    activeImage === index
                      ? "active-thumb"
                      : ""
                  }
                  onClick={() =>
                    setActiveImage(index)
                  }
                />

              )
            )}


          </div>


        </div>


        {/* =========================
            PRODUCT INFO
        ========================= */}

        <div className="details-info">


          <h1>
            {product.name}
          </h1>


          <p className="description">
            {product.description}
          </p>


          <h2>
            ${product.price}
          </h2>


          <p>
            Category:{" "}
            {product.category}
          </p>


          {/* =========================
              COLORS
          ========================= */}

          {product.colors?.length > 0 && (

            <>


              <h3>
                Choose Color
              </h3>


              <div className="colors">


                {product.colors.map(
                  color => (

                    <button
                      key={color}
                      className={
                        selectedColor === color
                          ? "color-btn selected-color"
                          : "color-btn"
                      }
                      style={{
                        background: color
                      }}
                      onClick={() =>
                        setSelectedColor(color)
                      }
                    />

                  )
                )}


              </div>


            </>

          )}


          {/* =========================
              SIZES
          ========================= */}

          {product.sizes?.length > 0 && (

            <>


              <h3>
                Choose Size
              </h3>


              <div className="sizes">


                {product.sizes.map(
                  size => (

                    <button
                      key={size}
                      className={
                        selectedSize === size
                          ? "selected-size"
                          : ""
                      }
                      onClick={() =>
                        setSelectedSize(size)
                      }
                    >

                      {size}

                    </button>

                  )
                )}


              </div>


            </>

          )}


          {/* =========================
              ADD TO CART
          ========================= */}

          <button
            className="add-cart"
            onClick={() => {


              if (
                product.colors?.length &&
                !selectedColor
              ) {

                alert(
                  "Choose Color"
                );

                return;

              }


              if (
                product.sizes?.length &&
                !selectedSize
              ) {

                alert(
                  "Choose Size"
                );

                return;

              }


              addToCart({

                ...product,

                color: selectedColor,

                size: selectedSize

              });


            }}
          >

            Add To Cart 🛒

          </button>


        </div>


      </div>


      {/* =========================
          YOU MAY ALSO LIKE
      ========================= */}

      <div className="related-section">


        <h2>
          You May Also Like 🤍
        </h2>


        {relatedProducts.length > 0 && (

          <div className="related-products">


            {relatedProducts.map(
              item => (

                <div
                  className="related-card"
                  key={item.id}
                >


                  <Link
                    to={`/product/${item.id}`}
                  >


                    <img
                      src={
                        item.images?.[0]
                      }
                      alt={item.name}
                    />


                    <h3>
                      {item.name}
                    </h3>


                    <p>
                      ${item.price}
                    </p>


                  </Link>


                </div>

              )
            )}


          </div>

        )}


      </div>


    </div>

  );

}


export default ProductDetails;